/* eslint-disable no-bitwise */
import React, { FC } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { ACCESS_AUTHENTICATED } from '../../../services/route/permissions';
import AuthCheck from '../../helpers/AuthCheck/AuthCheck';
import ShareMenuPage from './ShareMenuPage/ShareMenuPage';

const SharingFeature: FC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}`} exact>
        <AuthCheck authentication={ACCESS_AUTHENTICATED}>
          <ShareMenuPage />
        </AuthCheck>
      </Route>
    </Switch>
  );
};

export default SharingFeature;
